import React from 'react';
import { AccordionItemProvider } from '../AccordionItemContext';
import * as styles from './AccordionGroup.module.scss';

type Props = {
  children: JSX.Element | JSX.Element[];
  className?: string;
  initiallyOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const AccordionGroup = ({
  children,
  className,
  initiallyOpen = false,
  onToggle,
  ...props
}: Props) => {
  const classes = [styles.AccordionGroup];
  if (className) classes.push(className);

  return (
    <AccordionItemProvider initiallyOpen={initiallyOpen} onToggle={onToggle}>
      <div className={classes.join(' ')} {...props}>
        {children}
      </div>
    </AccordionItemProvider>
  );
};
